import { Typography } from '@/components';
import { SectionTitle } from '@/components/SectionTitle';
import { LayoutHierarchy, TextStyles } from '@/constants';
import styled, { type CSSProperties } from 'styled-components';

// Ref: components/Layout/Header/Header.styles.ts. Update this variable when has changed
const NAV_HEIGHT = 67;

const multiEllipsis: CSSProperties = {
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
};

export const HeaderContent = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing[10],
  padding: theme.spacing[20],
  backgroundColor: theme.colors.highEmphasisWhite,
  position: 'sticky',
  top: NAV_HEIGHT,
  zIndex: LayoutHierarchy.Fourth,

  [`${theme.mediaBreakpointUp.lg}`]: {
    position: 'initial',
    paddingBottom: 0,
  },
}));

export const BackArrowButton = styled.img.attrs({
  src: '/images/icons/arrow_back.svg',
  alt: 'Back Arrow',
})(({ theme }) => ({
  objectFit: 'none',
  height: 30,
  width: 20,
  marginRight: theme.spacing[10],
}));

export const TrackingIdText = styled(SectionTitle)<{ truncatedLines: number }>(({ theme, truncatedLines }) => ({
  fontStyle: 'normal',
  fontWeight: theme.fontWeight.semiBold,
  fontSize: theme.fontSizes[20],
  lineHeight: theme.lineHeight[30],
  maxHeight: truncatedLines === 2 ? 72 : 30,
  flex: 1,
  marginBottom: 0,
  color: theme.colors.highEmphasisBlack,
  wordBreak: 'break-all',
  span: {
    ...multiEllipsis,
    WebkitLineClamp: truncatedLines,
  },
}));

export const MerchantName = styled(Typography).attrs({
  variant: TextStyles['Heading 6'],
})(({ theme }) => ({
  color: theme.colors.darkOrange,
  textTransform: 'uppercase',
  ...multiEllipsis,
  WebkitLineClamp: 1,
  wordBreak: 'break-word',
  whiteSpace: 'pre-wrap',
}));

export const HeaderWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  flex: 1,

  [`${TrackingIdText}:after`]: {
    display: 'none',
  },
});
